import React from "react";
import { Spin } from "antd";

const GlobalLoader = () => {
    return (
        <>
        <div style={{position: 'fixed', top:'0', left:'0', height: '100vh', width: '100%', zIndex: '50000', backgroundColor:'#00000040'}}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh'}}>
                <Spin size="large"/>
            </div>
        </div>
        </>
    )
}

export default GlobalLoader